import useNavigateCustom from './UseNavigateCustom';
export default useNavigateCustom;